import { render, staticRenderFns } from "./filingPostManagement.vue?vue&type=template&id=5878dbad&scoped=true"
import script from "./filingPostManagement.vue?vue&type=script&lang=js"
export * from "./filingPostManagement.vue?vue&type=script&lang=js"
import style0 from "./filingPostManagement.vue?vue&type=style&index=0&id=5878dbad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5878dbad",
  null
  
)

export default component.exports